export const TERMS_OF_SERVICE_PATH = "/terms";
